"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headlineStyle = exports.default = exports.Text = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = _interopRequireDefault(require("@ux/text"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
const headlineStyle = exports.headlineStyle = "core-hcnpz2u";
const Text = exports.Text = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Text",
  class: "core-too7oxc"
});

/**
 * Render headline
 *
 * @param {Object} props React props
 * @param {String} props.headlineTag headlineTag
 * @param {String} props.heading header text
 * @param {String} props.className capturing styles
 * @param {String} props.headlineSize select headline size
 * @param {Number} props.headlineLineLength use a number to adjust the max-width of the text
 * @param {String} props.headingDataCy Cypress test name for specific heading text
 * @param {string} props.itemProp Used for associating structured data properties with an item for semantic markup purposes
 *
 * @returns {React.ReactElement} H1 element
 * @public
 */
function HeadlineString({
  headlineTag,
  heading,
  className = '',
  headlineSize = 'h1',
  headlineLineLength = 1.5,
  headingDataCy,
  itemProp,
  ...headlineProps
}) {
  if (!heading) {
    return null;
  }
  const HeadlineTag = headlineTag || 'p';
  const TextHeading = _text.default[HeadlineTag] || _text.default.p;
  const headlineAriaLevel = HeadlineTag === 'p' && headlineSize?.length > 0 ? {
    'role': 'heading',
    'aria-level': parseInt(headlineSize.substring(1), 10)
  } : {};
  return /*#__PURE__*/_react.default.createElement(TextHeading, (0, _extends2.default)({
    as: "heading",
    className: ['headline-string', 'multibrand-app', headlineSize, className, headlineStyle].filter(Boolean).join(' ')
  }, headlineAriaLevel, {
    style: headlineLineLength ? {
      maxWidth: `${headlineLineLength * 10}em`
    } : {}
  }, headlineProps, {
    "data-cy": "headline-string",
    itemProp: itemProp
  }), /*#__PURE__*/_react.default.createElement(Text, {
    "data-cy": headingDataCy
  }, heading));
}
HeadlineString.propTypes = {
  heading: _propTypes.default.node,
  headlineSize: _propTypes.default.oneOf(['d1', 'd2', 'd3', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'p']),
  headlineLineLength: _propTypes.default.number,
  headingDataCy: _propTypes.default.string,
  className: _propTypes.default.string,
  itemProp: _propTypes.default.string
};
var _default = exports.default = HeadlineString;